export class AbstractDTO {

    protected constructor(attributes?: object, args?) {}

    static create(attributes: object, ...args): any {
        args = args.length ? args : undefined;
        return new this(attributes || {}, args);
    }

    static createFromArray(collection: object[], ...args): any[] {
        args = args.length ? args : undefined;
        return (collection || []).map((attributes: object) => {
            return new this(attributes || {}, args);
        });
    }

}
